import React from "react";
import { CONCLUSAO_CADASTRO, CONCLUSAO_PRAZO } from "./conclusaoCadastro";
import { Constants } from "../../utils/Constants";
import "./CadastroConclusao.scss";

export default function CadastroConclusao({ variante = "matriz", onFechar }) {
	const copy = CONCLUSAO_CADASTRO[variante] || CONCLUSAO_CADASTRO.matriz;

	return (
		<div className="ff-conclusao-page" translate="no">
			<div className="ff-conclusao-card">
				<div className="ff-conclusao-card__icon" aria-hidden="true">
					<i className="fas fa-check" />
				</div>
				<h1 className="ff-conclusao-card__titulo">{copy.titulo}</h1>
				<p className="ff-conclusao-card__intro">{copy.intro}</p>
				<div className="ff-conclusao-card__prazo">{CONCLUSAO_PRAZO}</div>
				<p className="ff-conclusao-card__ajuda-titulo">Precisa de ajuda?</p>
				<p className="ff-conclusao-card__ajuda">Entre em contato com nossa Central de Relacionamento.</p>
				<a
					className="ff-conclusao-card__whatsapp"
					href={Constants.whatsappLink}
					target="_blank"
					rel="noopener noreferrer"
				>
					Falar pelo WhatsApp
				</a>
				<button type="button" className="ff-conclusao-card__fechar" onClick={onFechar}>
					Fechar
				</button>
				<p className="ff-conclusao-card__rodape">Agradecemos por escolher a FastFrete.</p>
			</div>
		</div>
	);
}
